export const TOAST_MESSAGE_STATUS_TYPE = {
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
};
